<template>
  <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item name='keyword' label='门店名称'>
      <a-input style="width: 270px" v-model:value="search.keyword" placeholder="请输入门店名称进行搜索" />
    </a-form-item>
    <a-form-item label="获得时间" name='time'>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
    </a-form-item>
    <a-form-item label="成长值类型" name='type'>
      <a-select v-model:value="search.type" :style="{width:'180px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">核销积分</a-select-option>
        <a-select-option :value="2">云店订单</a-select-option>
        <a-select-option :value="3">邀请分销员</a-select-option>
        <a-select-option :value="4">出货单累计商品</a-select-option>
        <a-select-option :value="5">邀请门店</a-select-option>
        <a-select-option :value="6">总部后台添加</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
    </a-form-item>
  </a-form>
  <div class='m-t-20'>
    <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='data'></a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </div>
</template>
<script>
  import { reactive, ref, toRefs,h } from "vue";
  import { getPointLog } from "@/api/assets";
  import { iscode } from "@/utils/app";
  import { getStoreGrowthValueLog } from '@/api/store'
  import { message,Modal } from "ant-design-vue";
  const def = {
    page: 1,
    limit: 10,
    start_time:'',
    end_time:'',
    keyword:'',
    type:''
  }
  export default {
    components: {  },
    name: "detailedList",
    setup() {
      const state = reactive({
        listLoading: false,
        total: 0,
        time:[]
      });
      let data = ref();
      let columns = [
        {
          title: "门店名称",
          dataIndex: "store_name",
          key: "store_name",
        },
        {
          title: "成长值类型",
          dataIndex: "type_text",
          key: "type_text",
        },
        {
          title: "获得成长值",
          dataIndex: "growth",
          key: "growth",
        },
        {
          title: "获取时间",
          dataIndex: "create_time",
          key: "create_time",
        }
      ];
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getStoreGrowthValueLog(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        }
        state.listLoading = false;
      };
      const search = ref({ ...def });
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //时间选择
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
      initData(search.value);
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        onChange
      };
    },
  };
</script>